import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { getIsFileReorderViewModeFile } from 'utils';
import {
  DATA_ROOM_NODE_ACCESS_LEVELS,
  DATA_ROOM_NODE_ACCESS_STATES,
} from 'models/Lead';
import DisplayFilesByCategoryTrigger from '../../../DisplayFilesByLead/components/DisplayFilesByCategoryTrigger';
import DisplayFilesByFileTrigger from '../../../DisplayFilesByLead/components/DisplayFilesByFileTrigger';

import './DisplayFilesPreview.styles.scss';

const CATEGORY_COUNT = {
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: 2,
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: 3,
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]: 1,
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: 4,
};

const FILE_NAME = {
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: 'NDA.pdf',
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: 'Teaser.pdf',
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]: 'Terms and conditions',
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: 'Information Memorandum',
};

const FILE_ACCESS_LEVEL = {
  [DATA_ROOM_NODE_ACCESS_STATES.VIEWED]: DATA_ROOM_NODE_ACCESS_LEVELS.DOWNLOAD,
  [DATA_ROOM_NODE_ACCESS_STATES.PENDING]: DATA_ROOM_NODE_ACCESS_LEVELS.VIEW,
  [DATA_ROOM_NODE_ACCESS_STATES.NOT_VIEWED]: DATA_ROOM_NODE_ACCESS_LEVELS.VIEW,
  [DATA_ROOM_NODE_ACCESS_STATES.NO_ACCESS]:
    DATA_ROOM_NODE_ACCESS_LEVELS.NO_ACCESS,
};

type DisplayFilesPreviewProps = {
  className?: string;
};

const DisplayFilesPreview: React.FC<DisplayFilesPreviewProps> = (props) => {
  const { className } = props;

  const classes = classNames('display-files-preview', className);

  const { t } = useTranslation();

  const {
    values: { fileReorderViewMode },
  } = useFormState();

  const isFilePreview = getIsFileReorderViewModeFile(fileReorderViewMode);

  return (
    <div className={classes}>
      <p>{t('preview')}</p>

      <div>
        {Object.values(DATA_ROOM_NODE_ACCESS_STATES).map((state) =>
          isFilePreview ? (
            <DisplayFilesByFileTrigger
              name={FILE_NAME[state]}
              accessLevel={FILE_ACCESS_LEVEL[state]}
              state={state}
            />
          ) : (
            <DisplayFilesByCategoryTrigger
              key={state}
              state={state}
              count={CATEGORY_COUNT[state]}
            />
          ),
        )}
      </div>

      <p>
        {t(
          isFilePreview
            ? 'viewSummaryByFileDescription'
            : 'viewSummaryByLeadDescription',
        )}
      </p>
    </div>
  );
};

export default DisplayFilesPreview;
